import { CardHeader, clx } from "@hm/fundamental"
import { ReactNode } from "react"

import { RoundedBox } from "../rounded-box"

interface InfoCardProps {
	title: string
	"data-cy"?: string
	className?: string
	aside?: ReactNode
	children?: ReactNode
	leftSpaceForIcon?: boolean
}

export const InfoCard = ({
	title,
	"data-cy": dataCy,
	className,
	aside,
	children,
	leftSpaceForIcon = false,
}: InfoCardProps) => (
	<RoundedBox
		data-cy={`${dataCy}-card`}
		className={clx("p-4 md:p-6", className)}
	>
		<div data-cy={`${dataCy}-container`} className="flex flex-col gap-3">
			<CardHeader
				data-cy={`${dataCy}-header`}
				className={clx(
					"!text-wrap",
					leftSpaceForIcon && "max-md:max-w-[calc(100%-48px)]",
				)}
				aside={aside}
			>
				{title}
			</CardHeader>

			{children && (
				<div
					data-cy={`${dataCy}-content`}
					className="flex flex-col gap-6"
				>
					{children}
				</div>
			)}
		</div>
	</RoundedBox>
)
